import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// --- Meta Pixel Initialization ---
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}
;
(function (f: any, b: Document, e: string, v: string) {
  if (f.fbq) return;
  const n: any = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = b.createElement(e) as HTMLScriptElement;
  t.async = true;
  t.src = v;
  const s = b.getElementsByTagName(e)[0];
  s.parentNode?.insertBefore(t, s);
})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
window.fbq('init', '962279486187488');
window.fbq('track', 'PageView');
render(<App data-id="element-247" />, document.getElementById('root'));